// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cU24","badges":"styles_badges__3aAGp"};